import { Future } from "./Future.mjs";
class Runnable {
    #_runnableFuture;
    #_currentStatus = Runnable.STATUSES.UNKNOWN;
    static STATUSES = Object.freeze({
        UNKNOWN: Symbol.for('unknown'),
        RUNNING: Symbol.for('running'),
        COMPLETED: Symbol.for('completed'),
        FAILED: Symbol.for('failed'),
        from: (status) => {
            if (Object.prototype.toString.call(status) === `[object String]`) {
                status = status.toLowerCase();
            }
            const possibleStatuses = Object.values(Runnable.STATUSES).toSpliced(-1);
            //If status passed in was a Symbol not a String
            if (possibleStatuses.includes(status)) {
                return status;
            }
            else {
                const found = possibleStatuses.find((possibleStatus) => possibleStatus.description === status);
                if (found) {
                    return found;
                }
                else {
                    return Runnable.STATUSES.UNKNOWN;
                }
            }
        }
    });
    /*****************************************************/
    /* START Lifecycle Methods */
    /*****************************************************/
    isRunning() {
        return this.statusAsEnum === Runnable.STATUSES.RUNNING;
    }
    isCompleted() {
        return this.statusAsEnum === Runnable.STATUSES.COMPLETED;
    }
    isFailed() {
        return this.statusAsEnum === Runnable.STATUSES.FAILED;
    }
    isFinished() {
        return this.isCompleted() || this.isFailed();
    }
    isUnknown() {
        return this.statusAsEnum === Runnable.STATUSES.UNKNOWN;
    }
    async whenFinished(...theArgs) {
        return this.run(...theArgs);
    }
    async run(...theArgs) {
        if (!this.#_runnableFuture) {
            this.#_currentStatus = Runnable.STATUSES.RUNNING;
            this.#_runnableFuture = new Future();
            try {
                const result = await this._run(...theArgs);
                this.#_currentStatus = Runnable.STATUSES.COMPLETED;
                this.#_runnableFuture.resolve(result);
            }
            catch (e) {
                this.#_currentStatus = Runnable.STATUSES.FAILED;
                this.#_runnableFuture.reject(e);
            }
        }
        return this.#_runnableFuture.promise;
    }

    /*****************************************************/
    /* END Lifecycle Methods */
    /* START ABSTRACT METHODS TO BE OVERRIDDEN */
    /*****************************************************/
    async _run() {
    }
    /*****************************************************/
    /* END ABSTRACT METHODS TO BE OVERRIDDEN */
    /* START Class Properties */
    /*****************************************************/
    get status() {
        return this.statusAsEnum.description.toUpperCase();
    }
    get statusAsEnum() {
        return Runnable.STATUSES.from(this.#_currentStatus);
    }
    /*****************************************************/
    /* END Class Properties */
    /*****************************************************/
}

export { Runnable };
export default Runnable;